<template>
  <span
    class="font-semibold cursor-pointer"
    :class="customClasses"
    v-tooltip="message"
  >
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: "Tooltip",
  props: {
    message: {
      type: String,
      required: true
    },
    customClasses: {
      type: Array,
      default: () => ['text-blue-400']
    }
  }
};
</script>
